import { h, Component } from 'preact';
import { IEmptyState, IMyServicesLinkProps } from '../sgwt-super-header.types';

const NavItem = require('react-bootstrap/lib/NavItem');

export default class MyServicesLink extends Component<IMyServicesLinkProps, IEmptyState> {
  constructor(props: IMyServicesLinkProps) {
    super(props);
  }

  render(props: IMyServicesLinkProps): JSX.Element {
    if (!props.isSGMarkets && props.hideServicesLink) {
      return <li/>;
    }
    const link = props.customLink || props.defaultLink;
    const label = props.customLabel || props.labels.myServicesLink;
    const icon = `fa ${ props.customIcon || 'fa-th' }`;
    return (
      <NavItem href={ link } id="sgwt-super-header-my-services-link">
        <i class={ icon }/><span> { label }</span>
      </NavItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/MyServicesLink.tsx